import { render, staticRenderFns } from "./userManualDetail.vue?vue&type=template&id=2debc723"
import script from "./userManualDetail.vue?vue&type=script&lang=js"
export * from "./userManualDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2debc723')) {
      api.createRecord('2debc723', component.options)
    } else {
      api.reload('2debc723', component.options)
    }
    module.hot.accept("./userManualDetail.vue?vue&type=template&id=2debc723", function () {
      api.rerender('2debc723', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/um/userManualDetail.vue"
export default component.exports